<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.931 21L10.491 19.7052C5.37655 15.1243 2 12.103 2 8.39509C2 5.37384 4.40331 3 7.46207 3C9.19007 3 10.8486 3.79455 11.931 5.05014C13.0135 3.79455 14.672 3 16.4 3C19.4588 3 21.8621 5.37384 21.8621 8.39509C21.8621 12.103 18.4855 15.1243 13.371 19.715L11.931 21Z"
  />
</template>
